export const INDIVIDUAL_PLAN = "Individual";
export const TEAM_PLAN = "Team";
export const ADDON_INTEGRATIONS = "Integration";
export const ADDON_CHAT = "Chat";
export const ADDON_INVOICING = "Invoicing";
export const TEAM_PLAN_AMOUNT = 12;
export const INDIVIDUAL_PLAN_AMOUNT = 8;
export const ANNUAL_DISCOUNT_PERCENTAGE = 25;
